<template>
  <RouterView/>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poetsen+One&display=swap');

* {
  box-sizing: border-box;
  font-family: 'Poetsen One', Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: ghostwhite;
}

#app {
  max-width: 480px;
  margin: 0 auto;
  padding: 16px;
  color: #2c3e50;
  background-color: ghostwhite;
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0;
}

.btn-back {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  color: #718096;
  display: flex;
  align-items: center;
}

.btn-back:hover {
  background: #e2e8f0;
}

.card-modern {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 16px;
}

.btn-primary-modern {
  background: #667eea;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 24px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary-modern:hover { background: #5a67d8; }
.btn-primary-modern:disabled { opacity: 0.4; cursor: not-allowed; }

.divider {
  border: none;
  border-top: 2px solid #e2e8f0;
  margin: 20px 0;
}

.score-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.score-table th {
  color: #718096;
  font-weight: 700;
  padding: 4px 6px;
  text-align: center;
  border-bottom: 2px solid #e2e8f0;
}

.score-table td {
  padding: 6px;
  text-align: center;
  border-bottom: 1px solid #f0f4f8;
}

.score-table .player-name {
  text-align: left;
  font-weight: 600;
  color: #2d3748;
}

.score-table .total-col {
  font-weight: 800;
  color: #667eea;
}

.score-table tr:last-child td {
  border-bottom: none;
}
</style>